import { SearchService } from './SearchService';

export class SearchCount<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;
	protected _stringTemplate: string;
	protected _stringTemplateWithKeyword: string;

	/**
	 *
	 * @param element
	 * @param searchService
	 * @param stringTemplate Example: "Showing {####} results"
	 */
	constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		stringTemplate: string = 'Showing {####} found of {length}',
		stringTemplateWithKeyword: string = 'Showing {####} results of {length} for <b>"{$$$$}"</b>',
	) {
		this._element = element;
		this._searchService = searchService;
		this._stringTemplate = stringTemplate;
		this._stringTemplateWithKeyword = stringTemplateWithKeyword;

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		const searchResult = this._searchService.algoliaResults;
		if(!searchResult) return;
		const hasKeyword = this._searchService.searchParams.textSearch !== '';
		const keyword = this._searchService.searchParams.textSearch;
		const count = searchResult?.hits.length || 0;
		const length = searchResult.nbHits;
		const content = (hasKeyword ? this._stringTemplateWithKeyword : this._stringTemplate)
			.replace('{####}', `${count}`)
			.replace('{length}', `${length}`)
			.replace('{$$$$}', `${keyword}`);

		this._element.empty().append(content);
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/SearchCount.ts